import firebase from "firebase";

var config = {
  apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
  authDomain: "tourbrazil-41fbe.firebaseapp.com",
  databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
  projectId: "tourbrazil-41fbe",
  storageBucket: "tourbrazil-41fbe.appspot.com",
  messagingSenderId: "927605208400"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const getCitys = () => {
  return dispatch => {
    const markers = firebase
      .database()
      .ref("cidades")
      .orderByChild("nome");
    markers.on("value", snapshot => {
      const city = [];
      snapshot.forEach(e => {
        const cityOne = { nome: e.child("nome").val(), id: e.key };
        city.push(cityOne);
      });
      return dispatch({ type: "CIDADES", payload: city });
    });
  };
};

export const sendCity = cidade => {
  return dispatch => {
    dispatch({ type: "CIDADES_ENVIADA", payload: "Enviando" });
    firebase
      .database()
      .ref("cidades")
      .push({
        nome: cidade
      })
      .then(value => {
        return dispatch({ type: "CIDADES_ENVIADA", payload: "Enviada" });
      });
  };
};

export const removeCity = cidadeId => {
  return dispatch => {
    dispatch({ type: "CIDADES_ENVIADA", payload: "Removendo" });
    firebase
      .database()
      .ref("cidades/" + cidadeId)
      .remove();
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/cidades.js